<script setup lang="ts">
import { getPhonePattern, getPhoneRegularExpression } from '@/js/phone-maska.ts';
import { vMaska } from 'maska/vue';
import { ref, watch } from 'vue';

const props = defineProps<{
  modelValue?: string
  isAccent?: boolean
  placeholder?: string
  required?: boolean
  name: string
}>();

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>();

const value = ref<string>();

watch(() => props.modelValue, (newVal) => {
  value.value = newVal;
}, {
  immediate: true,
});

function emitPhone() {
  emit('update:modelValue', value.value ?? '');
}
</script>

<template>
  <label class="base-field">
    <input
      v-model="value"
      v-maska="getPhonePattern()"
      :placeholder
      :pattern="getPhoneRegularExpression()"
      :required
      :name
      type="tel"
      inputmode="tel"
      @input="emitPhone"
    >
  </label>
</template>
